import { defineStore } from "pinia"
import { fetchInvestmentData } from "@/api/investment"
import { fetchPortfolioData } from "@/api/investment"
import { opportunities } from "@/api/product"
import { fetchSingleProduct } from "@/api/product"
import { fetchPortfolioItem, fetchGroupedProduct } from "@/api/investment"

export const useInvStore = defineStore("investment", {
  state: () => ({
    investments: [],
    portfolios: [],
    products: [],
    product: null,
    portfolioItem: [],
    groupedItem:[]
  }),

  actions: {
    async loadInvestmentType() {
      this.investments = []
      const res = await fetchInvestmentData()
      this.investments = res.data.data
    },
    async loadPortfolioSummary() {
      this.portfolios = []
       const res = await fetchPortfolioData()
       this.portfolios = res.data.data
       //console.log(res.data.data)
    },
    async loadProducts(id) {
      try {
        this.products.value = []
        const res = await opportunities(id)
        this.products = res.data.data || []
      } catch (error) {
        this.products = []
      }
    },
    async showProduct(slug){
      try {
        this.product.value = []
        const res = await fetchSingleProduct(slug)
        //console.log(res.data.data[0])
        this.product = res.data.data[0] ?? null
      } catch (error) {
        this.product = []
      }
    },
    async showPortfolioItem(id){
      try {
        this.portfolioItem.value = []
        const res = await fetchPortfolioItem(id)
        this.portfolioItem = res.data.data || []
      } catch (error) {
        this.portfolioItem = []
      }
    },
    async loadGroupedProducts(){
      try {
        this.groupedItem.value = []
        const res = await fetchGroupedProduct()
        this.groupedItem = res.data.data || []
        //console.log(this.groupedItem)
      } catch (error) {
        this.groupedItem = []
      }
    }

  }
})
